import React from "react";
import Router from "next/router";
import asPage from "components/core/as-page";
import Breadcrumbs from "components/core/breadcrumbs";
import Header from "components/core/header";
import HeaderBanner from "components/core/header-banner";
import Layout from "components/core/layout";
import Pagination from "components/elements/pagination";
import SVG from "components/elements/svg";
import HowItWorksButton from "components/partials/how-it-works-button";
import PropertiesFilters from "components/properties/properties-filters";
import {
  DEFAULT_FILTERS,
  NUMERIC_FILTERS,
  PROPERTIES_PER_PAGE,
} from "components/properties/properties-filters.defaults";
import PropertiesList from "components/properties/properties-list";
import scrollToElem from "helpers/scroll-to-elem";
import Error from "pages/_error";
import Api from "services/api";

class Properties extends React.Component {
  static getInitialProps({ res, query, tokens }) {
    const defaultFilters = { ...DEFAULT_FILTERS };
    const page = Number(query.page) || 1;

    Object.keys(query).forEach((key) => {
      const value = query[key];

      if (NUMERIC_FILTERS[key] !== undefined && NUMERIC_FILTERS[key]) {
        defaultFilters[key] = Number.parseFloat(value);
      } else if (DEFAULT_FILTERS[key] !== undefined) {
        defaultFilters[key] = value;
      }
    });

    if (!["sold", "publish"].includes(defaultFilters.status)) {
      defaultFilters.status = "publish";
    }

    return new Promise((resolve) => {
      new Api()
        .get(
          "/properties",
          {
            filters: defaultFilters,
            page,
            perPage: PROPERTIES_PER_PAGE,
          },
          tokens.token,
        )
        .then((response) =>
          resolve({
            status: 200,
            properties: response.properties,
            defaultFilters,
            page,
            lastPage: response.lastPage,
            tokens,
          }),
        )
        .catch((error) => {
          const statusCode = error.code;
          if (res) {
            res.statusCode = statusCode;
          }
          resolve({
            status: statusCode,
            properties: {},
            defaultFilters,
            tokens,
          });
        });
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      collapseFilters: true,
    };
  }

  updateFilters = (filters) => {
    scrollToElem(document.body);
    Router.push({
      pathname: "/properties",
      query: filters === null ? {} : { ...filters, page: 1 },
    });
  };

  changePage(selected) {
    if (selected !== this.props.page) {
      scrollToElem(document.body);
      Router.push({
        pathname: "/properties",
        query: { ...this.props.defaultFilters, page: selected },
      });
    }
  }

  collapseFilters(e) {
    e.preventDefault();
    if (window.innerWidth <= 768) {
      this.setState({ collapseFilters: !this.state.collapseFilters });
    }
  }

  render() {
    const { status, properties, page, lastPage, defaultFilters } = this.props;
    const title =
      defaultFilters.status === "publish" ? "Current Auctions" : "Sold";
    if (status !== 200) {
      return <Error statusCode={status} />;
    }

    return (
      <Layout className="properties-index" title="Properties">
        <Header>
          <HeaderBanner
            title="Properties"
            icon="properties-page"
            background="/static/images/header-properties.jpg"
          />
        </Header>

        <Breadcrumbs>
          <Breadcrumbs.Item title="Properties" url="properties" />
        </Breadcrumbs>

        <section className="properties">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-sm-4 col-xs-12">
                <button
                  type="button"
                  className="section-heading"
                  onClick={(e) => this.collapseFilters(e)}
                >
                  Advanced search
                  <SVG src="chevron-down" className="icon" />
                </button>
                <PropertiesFilters
                  defaultValue={defaultFilters}
                  collapse={this.state.collapseFilters}
                  onChange={this.updateFilters}
                />
              </div>
              <div className="col-lg-9 col-sm-8 col-xs-12 properties-column">
                <h2 className="section-heading">
                  {title} <SVG src="chevron-down" className="icon" />
                </h2>
                <PropertiesList properties={properties} />
                <Pagination
                  currentPage={page}
                  totalPages={lastPage}
                  onPageChange={(selected) => this.changePage(selected)}
                />
              </div>
              <div className="col-xs-12 how-it-works">
                <HowItWorksButton />
              </div>
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}

export default asPage(Properties);
